module.exports = __webpack_public_path__ + "media/bootstrap-icons/phone-e55a3692.svg";